// extracted by mini-css-extract-plugin
module.exports = {"termsAndConditionsWrapper":"terms-use_termsAndConditionsWrapper__xXbDV","header":"terms-use_header__ij5kX","customListContent":"terms-use_customListContent__U_TSY"};